import type { AppLocale } from '@ielts-buddy/shared'
import { t } from '../../i18n/messages.js'
import type { BottomTab } from '../router-store.js'
import { haptics } from '../telegram.js'
import { ChartBarIcon, HomeIcon, TrophyIcon, UserCircleIcon } from './icons.js'

const TABS: {
  id: BottomTab
  labelKey: string
  Icon: typeof HomeIcon
}[] = [
  { id: 'home', labelKey: 'nav.home', Icon: HomeIcon },
  { id: 'results', labelKey: 'nav.results', Icon: ChartBarIcon },
  { id: 'leaderboard', labelKey: 'nav.leaderboard', Icon: TrophyIcon },
  { id: 'profile', labelKey: 'nav.profile', Icon: UserCircleIcon },
]

export function BottomNav({
  active,
  locale,
  onSelect,
}: {
  active: BottomTab
  locale: AppLocale
  onSelect: (tab: BottomTab) => void
}) {
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 z-50 flex justify-center px-3 pb-[max(0.5rem,env(safe-area-inset-bottom))]">
      <nav
        aria-label="Main"
        className="pointer-events-auto flex max-w-md flex-1 items-center justify-around gap-0.5 rounded-[1.35rem] border border-brand-border bg-brand-surface/95 px-2 py-2 shadow-brand-lg backdrop-blur-md"
      >
        {TABS.map(({ id, labelKey, Icon }) => {
          const isActive = active === id
          return (
            <button
              key={id}
              type="button"
              onClick={() => {
                haptics.select()
                onSelect(id)
              }}
              className={`flex min-w-0 flex-1 flex-col items-center gap-0.5 rounded-xl py-1.5 transition-colors ${
                isActive
                  ? 'bg-brand-primary-soft text-brand-primary-strong'
                  : 'text-brand-text-muted active:bg-brand-bg-soft'
              }`}
            >
              <Icon className="h-6 w-6 shrink-0" />
              <span className="truncate text-[10px] font-semibold uppercase tracking-wide">
                {t(locale, labelKey)}
              </span>
            </button>
          )
        })}
      </nav>
    </div>
  )
}
